// Login.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { loginUser } from "./apiservice";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,16}$/;
    return passwordRegex.test(password);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    if (!validatePassword(password)) {
      setError("Password must be 8-16 characters long, contain at least one letter, one number, and one special character (!@#$%^&*)");
      return;
    }

    try {
      const response = await loginUser(email, password);
      // Token is already stored in localStorage by loginUser in apiservice.js
      // If the API response structure differs, adjust here: localStorage.setItem("token", response.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "An error occurred during login");
    }
  };

  const gradientSecondary = {
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
  };

  const cardStyle = {
    width: '100%',
    maxWidth: '28rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    borderRadius: '0.5rem',
    overflow: 'hidden'
  };

  const cardHeaderStyle = {
    textAlign: 'center',
    padding: '1.5rem',
    spaceY: '0.5rem'
  };

  const iconContainerStyle = {
    display: 'inline-block',
    width: '3rem',
    height: '3rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 1rem'
  };

  const titleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent'
  };

  const cardContentStyle = {
    padding: '1.5rem'
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  };

  const labelStyle = {
    fontSize: '0.875rem',
    fontWeight: '500'
  };

  const inputStyle = {
    padding: '0.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    fontSize: '1rem'
  };

  const errorStyle = {
    color: '#ef4444',
    fontSize: '0.875rem'
  };

  const buttonStyle = {
    width: '100%',
    padding: '0.75rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '0.375rem',
    fontSize: '1rem',
    cursor: 'pointer',
    opacity: 1,
    transition: 'opacity 0.2s'
  };

  return (
    <div style={{ ...gradientSecondary, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={cardStyle}>
        <div style={cardHeaderStyle}>
          <div style={iconContainerStyle}>
            <Shield style={{ width: '1.5rem', height: '1.5rem', color: 'white' }} />
          </div>
          <h2 style={titleStyle}>Super Admin Login</h2>
        </div>
        <div style={cardContentStyle}>
          <form onSubmit={handleLogin} style={formStyle}>
            <div style={formGroupStyle}>
              <label htmlFor="email" style={labelStyle}>Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
                style={inputStyle}
              />
            </div>
            <div style={formGroupStyle}>
              <label htmlFor="password" style={labelStyle}>Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={inputStyle}
              />
            </div>
            {error && (
              <div style={errorStyle}>{error}</div>
            )}
            <button type="submit" style={{ ...buttonStyle, ':hover': { opacity: 0.9 } }} onMouseOver={(e) => e.target.style.opacity = '0.9'} onMouseOut={(e) => e.target.style.opacity = '1'}>
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}